

import Category from "./Category.vue";
import { RouteName } from "./routenames";

export default {
    props: {
        pagetitle: {
            type: String,
            required: true,
        }
    },

    components: {
        "category": Category,
    },

    data() {
        return {
            prevRoute: "",
            nextRoute: "",
            routename: "",
            isVideoRoute: this.$route.name == RouteName.VideoRoute,
        };
    },

    methods: {
        animationname() {
            if(this.prevRoute == RouteName.VideoRoute && this.nextRoute == RouteName.CategoryRoute) {
                return "scalereversed";
            }
            if(this.prevRoute == RouteName.VideoRoute && this.nextRoute == RouteName.VideoRoute) {
                return "slide";
            }
            return "scale";
        }
    },

    watch: {
        $route: function(nextRoute, prevRoute){
            this.prevRoute = prevRoute.name;
            this.nextRoute = nextRoute.name;
            this.routename = this.$route.name;

            if(this.nextRoute == RouteName.VideoRoute) {
                this.isVideoRoute = true;
            } else {
                var self = this;
                setTimeout(function(){
                    self.isVideoRoute = false;
                }, 500);
            }
        }
    }


}
